import store from "../store";

const socketConnection = () => {
    return new WebSocket(`${process.env.VUE_APP_SOCKET}/?token=${store.getters['auth/token']}`);
}

export default {
    socketConnection
}
